import moment from 'moment';

/** COMPANY_PAYMENT_TYPE ek değeri 1 = Nakit (CompanyPaymentTypeEnum.NAKIT). */
export const ODEME_SEKLI_NAKIT = '1';

/**
 * Fatura ödeme tarihi (19.10.2026, Burak): ödeme şekli Nakit ise fatura tarihiyle aynı gün;
 * değilse fatura tarihi + vade günü; vade ya da fatura tarihi yoksa boş.
 */
export function odemeTarihiHesapla(odemeSekliKodu: string | undefined | null, vadeGunu: string | undefined | null, faturaTarihi: string | undefined | null): string {
    if (!faturaTarihi || faturaTarihi.trim() == '')
        return '';
    if (odemeSekliKodu == ODEME_SEKLI_NAKIT)
        return faturaTarihi;
    if (odemeSekliKodu && vadeGunu && !isNaN(parseInt(vadeGunu)))
        return moment(faturaTarihi, 'YYYY-MM-DD').add(parseInt(vadeGunu), 'days').format('YYYY-MM-DD');
    return '';
}
